import localStore from './localStore'

class MyUtil{
  /**一页10条数据 */
  static PAGE_SIZE_10=10

  /**一页20条数据 */
  static PAGE_SIZE_20=20

  
  /***打印日志 */
	static e(...params){
    console.log('【lqc】',...params)
  }
  
  /***延迟执行 */
  static delayRun(callBack,delay=1000,){
    setTimeout(function(){
      if(callBack) callBack()
    }, delay);
  }

  static getLocalCart() {
    let cartData=localStore.get('TUP_cart') || {
      'promotion': [],
      'product': [],
      'giftProducts': [],
      'needGiftProduct': 1
    }
    //console.log("----------------getLocalCart-----------------------")
    cartData.promotion=cartData.promotion.map(item=>{
      item.type=Number(item.type) //强转数字类型：兼容
      return item
    })
    return cartData
  }

}

export {
  MyUtil
}


// WEBPACK FOOTER //
// ./src/util/MyUtil.js